// IE 2026 10 28 / ODOO-5800 (заказ Игоря: раздел Fix dates в форме ячейки)
// Раздел FIX DATES (uk «ДАТИ ФІКСАЦІЇ», ru «ДАТЫ ФИКСАЦИИ») формы ячейки: даты фиксации автоплана распределения — записи AUTOPLAN-DATE (мера DO_manual) ячейки:
// посмотреть, поставить «до даты», снять (архив записи), открыть список с отбором. Контракт — ie-dm7 work-cell-fix-dates.md, бэк PR #551 (main 0525067bf),
// common_modules/cell_fix_dates.py:
//   1) ответ cell_passport несёт ключ fix_dates (только у мер DO_IN/DO_OUT/IN/OUT_autoplan, IN/OUT/open_balance_uncovered, DO_manual и IN / OUT строк
//      distr_group | Consignment); нет ключа — раздела нет; ошибка — {state: 'error: …'} → строка ошибки в разделе (fixDates_model);
//   2) методы виджета отчёта cell_fix_date_set {object, subject, date_to, measure_type, scope} и cell_fix_date_remove {id} — ответ {<метод>: {state, …}}
//      (fixDates_setParams / fixDates_removeParams / fixDates_result); после ok форма перечитывается тем же путём, что при открытии (fixDates_send →
//      AttrGrid.cellPassport_load, как cellSignalAccept.accept_send);
//   3) «Open list» — fix_dates.list {widget, where, chipTitle} → ссылка {kind: 'widget'} Dropdown.linkOpen (store.cellRulesList_open + cellRules_chip:
//      чипс в памяти вкладки, стол не меняется) — fixDates_listLink.
// Выключатель фронта fe.ux.cellFixDates (дефолт ВКЛ; выкл — раздела нет); бэка — not-cell_fix_dates (ключа нет, методы отвечают state 'off').
import { t, tn } from '@/i18n'
import { accept_reloadCell } from '@/utils/cellSignalAccept'

export const FIX_DATES_FLAG = 'fe.ux.cellFixDates'
export const SET_METHOD = 'cell_fix_date_set'
export const REMOVE_METHOD = 'cell_fix_date_remove'
export const MEASURE_TYPES = ['', 'distr_group', 'Consignment']
export const SCOPES = ['version', 'all']

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))
const str = (v) => (v === undefined || v === null) ? '' : String(v).trim()

// чтение флага: нет читателя / ошибка — ВКЛ
export function fixDates_on(setting) {
    try { return typeof setting === 'function' ? setting(FIX_DATES_FLAG, true) !== false : true } catch (e) { return true }
}

// 'YYYY-MM-DD' настоящей даты (2026-02-30 — нет)
export function fixDates_validDate(d) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str(d))
    if (!m) return false
    const dt = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]))
    return dt.getUTCFullYear() === +m[1] && dt.getUTCMonth() === +m[2] - 1 && dt.getUTCDate() === +m[3]
}

// время ISO бэка → 'YYYY-MM-DD HH:MM'; не строка — ''
function _at(v) { const s = str(v); return s ? s.slice(0, 16).replace('T', ' ') : '' }

// варианты списка {id, title} бэка; нет — умолчания (подписи — t())
function _opts(list, ids, titles) {
    const out = Array.isArray(list) ? list.filter(isObj).map(o => ({ id: str(o.id), title: str(o.title) || str(o.id) || t('All') })) : []
    return out.length ? out : ids.map((id, i) => ({ id, title: titles[i] }))
}

// строка записи раздела
function _item(x, i) {
    const link = isObj(x.link) && str(x.link.id) && str(x.link.segment) ? { kind: 'record', id: str(x.link.id), segment: str(x.link.segment), title: str(x.link.title) }
        : (str(x.id) && str(x.segment) ? { kind: 'record', id: str(x.id), segment: str(x.segment), title: '' } : null)
    const o = {
        key: str(x.id) || ('fd:' + i), id: str(x.id), segment: str(x.segment) || 'AUTOPLAN-DATE',
        date_to: str(x.date_to).slice(0, 10), dateText: str(x.date_to_text) || str(x.date_to).slice(0, 10),
        measureType: str(x.measure_type), measureTypeTitle: str(x.measure_type_title) || (str(x.measure_type) || t('All')),
        scope: str(x.scope), scopeTitle: str(x.scope_title) || str(x.scope), version: str(x.version),
        object: str(x.object), objectTitle: str(x.object_title) || str(x.object) || t('All products'),
        subject: str(x.subject), subjectTitle: str(x.subject_title) || str(x.subject) || t('All warehouses'),
        status: str(x.status), statusTitle: str(x.status_title) || str(x.status),
        covers: x.covers_cell === true, effective: x.effective === true,
        by: str(x.by_title) || str(x.by), at: _at(x.at), updatedBy: str(x.updated_by_title) || str(x.updated_by), updatedAt: _at(x.updated_at),
        link, canRemove: x.can_remove === true && !!str(x.id),
    }
    o.who = [o.by, o.at].filter(Boolean).join(' · ')
    o.changed = (o.updatedAt && o.updatedAt !== o.at) ? [o.updatedBy, o.updatedAt].filter(Boolean).join(' · ') : ''
    o.scopeText = o.scope === 'version' && o.version ? o.scopeTitle + ' (' + o.version + ')' : o.scopeTitle
    return o
}

// модель раздела из cell_passport.fix_dates: null — ключа нет / не объект / неизвестное состояние; {error} — ошибка бэка (строка в разделе);
// иначе {title, hint, note, cell, items, n, truncated, effective, canSet, setHint, defaults, measureTypes, scopes, actions, list, summary}
export function fixDates_model(raw) {
    if (!isObj(raw)) return null
    const state = str(raw.state)
    if (state.startsWith('error')) {
        const detail = state.replace(/^error:?\s*/, '')
        return { error: t('Fix dates are not available') + (detail ? ': ' + detail.slice(0, 160) : ''), items: [], summary: t('error'), canSet: false, list: null }
    }
    if (state && state !== 'ok') return null
    const items = Array.isArray(raw.items) ? raw.items.filter(isObj).map(_item) : []
    const eff = isObj(raw.effective) && (str(raw.effective.date_to) || str(raw.effective.id)) ? {
        id: str(raw.effective.id), date_to: str(raw.effective.date_to).slice(0, 10),
        dateText: str(raw.effective.date_to_text) || str(raw.effective.date_to).slice(0, 10), covers: raw.effective.covers_cell === true } : null
    const d = isObj(raw.defaults) ? raw.defaults : {}
    const cell = isObj(raw.cell) ? raw.cell : {}
    const defaults = {
        object: str(d.object) || str(cell.object), subject: str(d.subject) || str(cell.subject),
        date_to: fixDates_validDate(str(d.date_to)) ? str(d.date_to) : '',
        measure_type: MEASURE_TYPES.includes(str(d.measure_type)) ? str(d.measure_type) : '',
        scope: SCOPES.includes(str(d.scope)) ? str(d.scope) : 'version',
    }
    const actions = isObj(raw.actions) ? raw.actions : {}
    const m = {
        error: '', title: str(raw.title), hint: str(raw.hint), note: str(raw.note),
        cell: { object: str(cell.object), subject: str(cell.subject), month: str(cell.month), version: str(cell.version), measure: str(cell.measure), measure_type: str(cell.measure_type) },
        items, n: Number.isFinite(Number(raw.n)) && raw.n !== null && raw.n !== '' ? Number(raw.n) : items.length, truncated: raw.truncated === true,
        effective: eff, canSet: raw.can_set === true && !!defaults.object && !!defaults.subject, setHint: str(raw.set_hint), defaults,
        measureTypes: _opts(raw.measure_types, MEASURE_TYPES, [t('All'), 'Ex-Delta', t('Consignment')]),
        scopes: _opts(raw.scopes, SCOPES, [t('This calculation version'), t('All versions')]),
        actions: { set: str(actions.set) || SET_METHOD, remove: str(actions.remove) || REMOVE_METHOD },
        list: fixDates_listLink(raw.list),
    }
    m.summary = fixDates_summary(m)
    return m
}

// сводка свёрнутого раздела: «until 30.11.2026» (решающая запись) / «until 30.11.2026 · the month is after the date» / «2 records» / «No fix date»
export function fixDates_summary(m) {
    if (!isObj(m)) return ''
    if (m.error) return t('error')
    if (m.effective && m.effective.dateText) return t('until {date}', { date: m.effective.dateText }) + (m.effective.covers ? '' : ' · ' + t('the month is after the date'))
    const n = m.n || (m.items || []).length
    if (!n) return t('No fix date')
    return tn(n, '{n} record', '{n} records') + ' · ' + t('none applies to the cell')
}

// ссылка «Open list»: fix_dates.list → {kind: 'widget', widget, where, chipTitle, title} (Dropdown.linkOpen); нет виджета — null
export function fixDates_listLink(list) {
    if (!isObj(list) || !str(list.widget)) return null
    return { kind: 'widget', widget: str(list.widget), where: Array.isArray(list.where) ? list.where : [], chipTitle: str(list.chipTitle) || str(list.title), title: str(list.title) || 'Fix dates' }
}

// ключ ячейки раздела (строка результата set / remove — только у своей ячейки): 'object|subject|month|version|measure|measure_type'; нет модели — ''
export function fixDates_cellKey(m) {
    const c = isObj(m) && isObj(m.cell) ? m.cell : null
    return c ? [c.object, c.subject, c.month, c.version, c.measure, c.measure_type].join('|') : ''
}

// начальная форма «Set until date» по defaults модели: {date_to, measure_type, scope}
export function fixDates_form(m) {
    const d = isObj(m) && isObj(m.defaults) ? m.defaults : {}
    return { date_to: str(d.date_to), measure_type: str(d.measure_type), scope: SCOPES.includes(str(d.scope)) ? str(d.scope) : 'version' }
}

// params метода cell_fix_date_set: модель с canSet + форма {date_to, measure_type, scope}; дата не YYYY-MM-DD / неизвестный тип или область — null
export function fixDates_setParams(m, form) {
    if (!isObj(m) || !m.canSet || !isObj(m.defaults)) return null
    const f = isObj(form) ? form : {}
    const date_to = str(f.date_to), measure_type = str(f.measure_type), scope = str(f.scope) || 'version'
    if (!fixDates_validDate(date_to) || !MEASURE_TYPES.includes(measure_type) || !SCOPES.includes(scope)) return null
    return { object: m.defaults.object, subject: m.defaults.subject, date_to, measure_type, scope }
}

// params метода cell_fix_date_remove: строка с canRemove → {id}; иначе null
export function fixDates_removeParams(item) {
    return isObj(item) && item.canRemove && str(item.id) ? { id: str(item.id) } : null
}

// ответ метода → {ok, off, already, state, text}. answer — ответ executeWidgetMethod ({<метод>: {...}}) либо сам объект метода.
// ok — state 'ok'; off — выключатель бэка (действия прячутся); error: … — текст ошибки. kind — 'set' | 'remove' (нет — по имени метода)
export function fixDates_result(answer, method = SET_METHOD, kind = '') {
    const a = isObj(answer) ? answer : {}
    const r = isObj(a[method]) ? a[method] : (typeof a.state === 'string' ? a : { state: 'error' })
    const state = str(r.state) || 'error'
    const rm = kind ? kind === 'remove' : method === REMOVE_METHOD
    const base = { ok: false, off: false, already: r.already === true, state, id: str(r.id), text: '' }
    if (state === 'off') return { ...base, off: true, text: t('Fix dates are switched off ({switch})', { switch: str(r.switch) || 'cell_fix_dates' }) }
    if (state === 'ok') {
        const date = isObj(r.record) ? str(r.record.date_to_text) || str(r.record.date_to).slice(0, 10) : ''
        const head = rm ? (base.already ? t('The fix date was already removed') : t('The fix date is removed'))
            : (base.already ? t('The fix date is already set') : (date ? t('The fix date is set until {date}', { date }) : t('The fix date is set')))
        return { ...base, ok: true, text: head + (base.already ? '' : '. ' + t('Recalculate the product to apply')) }
    }
    const detail = state.replace(/^error:?\s*/, '')
    return { ...base, text: (rm ? t('The fix date is not removed') : t('The fix date is not set')) + (detail ? ': ' + detail.slice(0, 160) : '') }
}

// вызов метода и перечитывание формы после ok (путь открытия формы — AttrGrid.cellPassport_load, как accept_send):
// grid — AttrGrid формы (store, WIDGET, flex, cellPassport_load), dropdown — форма (key, dataItem, visible, vueObj);
// req: {method: SET_METHOD | REMOVE_METHOD (или имя из fix_dates.actions), kind: 'set' | 'remove', params, done(result)}; тост — store.show_notification
export function fixDates_send(grid, dropdown, req) {
    const done = req && typeof req.done === 'function' ? req.done : () => {}
    const kind = req && req.kind === 'remove' ? 'remove' : 'set'
    const method = str(req && req.method) || (kind === 'remove' ? REMOVE_METHOD : SET_METHOD)
    const store = grid && grid.store
    const fail = { ok: false, off: false, already: false, state: 'error', id: '', text: kind === 'remove' ? t('The fix date is not removed') : t('The fix date is not set') }
    if (!store || typeof store.executeWidgetMethod !== 'function' || !req || !isObj(req.params)) { done(fail); return false }
    const ddKey = dropdown ? dropdown.key : undefined
    const opts = { record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true }
    const note = (text, status) => { try { store.show_notification({ text, status, timeout: 7000 }) } catch (e) { /* стора уведомлений нет */ } }
    store.executeWidgetMethod({ WIDGET: grid.WIDGET }, { command: 'executeWidgetMethod', method, params: req.params, ...opts,
        _response_callback: (answer) => {
            if (answer) { answer.command = ''; delete answer.updates }   // ответ нужен только форме (как у cell_passport)
            const res = fixDates_result(answer, method, kind)
            done(res)
            note(res.text, res.ok ? 'success' : 'warning')
            if (!res.ok || typeof grid.cellPassport_load !== 'function') return
            if (!dropdown || dropdown.key !== ddKey || dropdown.visible === false || (dropdown.vueObj && dropdown.vueObj !== grid)) return   // форма закрыта / уже на другой ячейке
            const c = accept_reloadCell(grid, dropdown)
            if (c) { try { grid.cellPassport_load(dropdown, c.dataItem, c.binding, c.irow); return } catch (e) { /* ниже — плашка */ } }
            note(t('Reopen the cell form to see the change'), 'info')
        } })
    return true
}
